<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
      <el-form-item label="主题名称" prop="subject">
        <el-input
          v-model="queryParams.subject"
          placeholder="请输入主题名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="是否收费" prop="flag">
        <el-select v-model="queryParams.flag" clearable  placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期" prop="datetime">
        <el-date-picker
          v-model="datetime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          @change="change"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="tableData"
      height="calc(100vh - 290px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :row-style="{ height: '58px' }"
    >
      <el-table-column
        label="主题名称"
        align="center"
        prop="title"
        :show-overflow-tooltip="true"
      >
      </el-table-column>

      <el-table-column
        label="报名人数"
        align="center"
        prop="timesTotal"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="报名次数"
        align="center"
        prop="personTotal"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="主题时间" align="center" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
        <template slot-scope="scope">
          <span>{{ formatDateTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope" v-if="scope.row.userId !== 1">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleExamine(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      @pagination="getList"
    />
    <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      size="28%"
      :withHeader="false"
    >
      <div class="drawer-content">
        <div class="drawer-content-top">
          <div class="drawer-content-top-left">
            <img :src="InfoArry.createHeadUrl" alt="" />
            <span>{{ InfoArry.createAlias }}</span>
          </div>
          <p class="content-top-cyrs">参与人次：{{ personTotalNum }}人</p>
        </div>
        <div class="drawer-content-middle">
          <p>{{ InfoArry.title }}</p>
          <div>
            <span class="drawer-content-fz"
              >{{ InfoArry.createTime }} 发布</span
            >
            |
            <span class="drawer-content-fz">将于 {{ InfoArry.endTime }}</span>
          </div>
          <p>{{ InfoArry.content }}</p>
        </div>
        <div class="drawer-content-bottom">
          <h3>参与用户</h3>
          <ul>
            <li v-for="(item, index) in useArry" :key="index">
              <div class="drawer-content-bottom-left">
                <span class="drawer-content-index">{{ index + 1 }}</span>
                <img :src="item.headUrl" alt="" />
                <span class="drawer-content-fz">{{ item.aliasName }}</span>
              </div>
              <span class="drawer-content-fz">{{ item.peopleNum }}人</span>
              <span class="drawer-content-fz">{{ item.dealTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
  
<script>
import {
  reportSubject,
  querySubInfo,
  reportDetailList,
} from "@/api/meal/MealDetails";
import moment from "moment";
export default {
  data() {
    return {
      tableData: [],
      direction: "rtl",
      drawer: false,
      // 总条数
      total: 0,
      // 遮罩层
      loading: false,
      // 非多个禁用
      multiple: true,
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {},
      options: [
        {
          value: true,
          label: "计费",
        },
        {
          value: false,
          label: "不计费",
        },
      ],
      datetime: [],
      useArry: [],
      InfoArry: {},
      personTotalNum: 0,
      fromParams: {
        sAliasName: '',
        subjectName: '',
        isCharge: '',
        subjectId: "",
        beginTime: '',
        endTime: '',
        limit: 100,
        page: 1,
      },
      queryParams: {
        subject: "",
        flag: '',
        startDate: "",
        endDate: "",
        limit: 10,
        page: 1,
      },
      selectedYear: "",
      currentYear: new Date().getFullYear(),
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatDateTime(dateString) {
      return moment(dateString).format("YYYY-MM-DD HH:mm:ss"); // 自定义格式
    },
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data, total } = await reportSubject(this.queryParams);
      this.tableData = data;
      this.total = total;
      this.loading = false;
    },

    //选择日期
    change(e) {
      this.queryParams.page = 1; // 日期区间筛选：回到第 1 页
      if (e) {
        this.queryParams.startDate = e[0];
        this.queryParams.endDate = e[1];
      } else {
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
      }
      this.getList();
    },
    async handleExamine(e) {
      this.fromParams.subjectId = String(e.sId);
      this.fromParams.isCharge = this.queryParams.flag == true ? 1 : null;
      this.personTotalNum = e.timesTotal;
      //获取主题信息
      let Info = await querySubInfo(e.sId);
      this.InfoArry = Info.result;
      //获取参与用户信息
      let { data, code } = await reportDetailList(this.fromParams);
      this.useArry = data;
      if (code == 200) {
        this.drawer = true;
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.datetime = [];
      this.queryParams = {
        subject: '',
        flag: '',
        startDate: '',
        endDate: '',
        limit: 10,
        page: 1,
      };
      this.getList();
    },
  },
};
</script>
  
  <style scoped lang="scss">
.drawer-content {
  margin-top: 20px;
  padding: 0 10px 0 30px;
}
.drawer-content-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.drawer-content-top-left {
  display: flex;
  align-items: center;
}
.drawer-content-top-left img {
  width: 60px;
  height: 60px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
}
.content-top-cyrs {
  margin-right: 20px;
}
.drawer-content-middle p {
  padding: 0;
  margin: 5px 0;
}
.drawer-content-bottom h3 {
  text-align: center;
  border-bottom: 1px solid pink;
  padding-bottom: 10px;
}
.drawer-content-bottom ul {
  padding: 0;
  height: 660px;
  overflow: auto;
}
.drawer-content-bottom ul li {
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid pink;
  padding: 8px 10px;
}
.drawer-content-bottom-left {
  display: flex;
  align-items: center;
  width: 160px;
}
.drawer-content-bottom-left img {
  width: 40px;
  height: 40px;
  display: inline-block;
  border-radius: 50%;
  margin: 0 20px;
}
.drawer-content-index {
  margin-right: 20px;
  font-size: $font-size-base;
  color: #999;
  width: 20px;
}
.drawer-content-fz {
  font-size: $font-size-base;
}
.demo-table-expand {
  font-size: 0;
  padding: 0 50px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
::v-deep .el-form--inline .el-form-item__label {
  font-weight: 600;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>